const Style = {
  base: 'relative block text-brand-text-primary text-sm -mt-1 mb-4 py-2 px-3 bg-red-500 rounded-b',
}

export default Style
